import { Sentry } from "./sentryInstrument";
import { handleSiteModal } from "./util/modalHelperFunctions";

const dialogs = document.querySelectorAll(".popity");
const popityContainer = document.getElementById("popity-container");
let isOpenDialogPresent;


function sanitizeQueryValue(rawValue, maxLength = 200) {
  if (typeof rawValue !== "string") {
    return null;
  }

  const value = rawValue.trim();
  if (!value || value.length > maxLength) {
    return null;
  }

  // Basic sanity check to reject obvious payloads.
  if (/[\x00-\x1F\x7F<>"'`]/.test(value)) {
    return null;
  }

  return value;
}

function sanitizeReferrer(rawReferrer) {
  const referrer = sanitizeQueryValue(rawReferrer, 1000);
  if (!referrer) {
    return null;
  }

  try {
    const parsed = new URL(referrer);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return null;
    }
    return parsed.toString();
  } catch {
    return null;
  }
}

// fetch URL Contents
async function fetchPopity() {
  const url = new URL("/ads/popity.html", window.location.origin);
  const currentParams = new URLSearchParams(window.location.search);
  const sanitizedParams = new URLSearchParams();

  for (const [key, value] of currentParams.entries()) {
    const safeKey = sanitizeQueryValue(key, 80);
    const safeValue = sanitizeQueryValue(value);
    if (!safeKey || !safeValue) {
      continue;
    }
    sanitizedParams.append(safeKey, safeValue);
  }

  const safeReferrer = sanitizeReferrer(document.referrer);
  if (safeReferrer) {
    sanitizedParams.set("ref", safeReferrer);
  }

  url.search = sanitizedParams.toString();

  try {
    const response = await fetch(url.toString());
    if (response.ok) {
      return response.text();
    } else {
      console.log("There was an error: " + response.status);
	  return "";
    }
  } catch (error) {
    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error("Sentry is not initialized", error);
    }
    return "";
  }
}


// Safely open a modal, catching any errors from showModal()
function safeOpenModal(popity) {
  try {
    handleSiteModal(popity, "open");
  } catch (error) {
    // showModal() can throw if dialog is invalid or already open
    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error("Failed to open popity modal", error);
    }
  }
}

// detect if any other dialog modals are open
function openDialogsPresent(popity) {
  isOpenDialogPresent = false;

  dialogs.forEach((dialog) => {
    if (dialog.open) {
      isOpenDialogPresent = true;
    } 
  });

  if (isOpenDialogPresent) {
    setTimeout(() => openDialogsPresent(popity), 3000);
  } else {
    safeOpenModal(popity);
  }
}


document.addEventListener("DOMContentLoaded", () => {
  let modalOpened = false;

  if (popityContainer === null) {
    return;
  }

  fetchPopity().then(popityHTML => {
	const wrap = document.createElement("div");
    wrap.innerHTML = popityHTML;
	popityContainer.appendChild(wrap);

    const popities = document.querySelectorAll(".popity");
    popities.forEach((popity) => {
      const popityID = Number(popity.dataset.id);
      if (!modalOpened) {
  
        // trigger functionality
        const popityTrigger = popity.dataset.trigger;
        
        if (popityTrigger === "load") {
  
          safeOpenModal(popity);
  
        } else if (popityTrigger === "3delay") {
  
          setTimeout(() => openDialogsPresent(popity), 3000);
  
        } else if (popityTrigger === "25scroll") {
  
          let modalScrollTriggered = false;
          window.addEventListener("scroll", () => {
            if (!modalScrollTriggered) {
              const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
              if (scrollPercentage >= 25) {
                safeOpenModal(popity);
                modalScrollTriggered = true;
              }
            }
          });
          
        }
        modalOpened = true; // prevents more than one popity modal from showing
      } 
    
    });

  }).catch(error => {
    // Catch any unhandled errors in the promise chain
    if (Sentry && Sentry.captureException) {
      Sentry.captureException(error);
    } else {
      console.error("Error in popity initialization", error);
    }
  });
     
});


